import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, CreditCard, Lock, XCircle } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full" data-id="element-33" data-mp="28tuwyyf555f7">
      {/* SECTION 1 - HERO */}
      <section className="bg-court-wash relative pt-8 sm:pt-16 pb-12 sm:pb-20 px-4 sm:px-6 lg:px-8" data-id="element-34" data-mp="28uefag8pdvtr">
        <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-35" data-mp="2wltnuqr2p9dg">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center w-full" data-id="element-36" data-mp="30newfzwkr1hu">
            {/* Brand label */}
            <div className="flex items-center gap-2 mb-5 sm:mb-8" data-id="element-37" data-mp="3kacul1uh5e3f">
              <span className="text-lg" data-id="element-38" data-mp="2ff8uwvil0awh">🎾</span>
              <span className="text-court-deep font-heading font-bold text-sm sm:text-base tracking-[0.25em] uppercase" data-id="element-39" data-mp="2fg1sb5vnho1y">
                Class Room
              </span>
            </div>

            <h1 className="text-[32px] leading-[1.05] sm:text-6xl lg:text-7xl font-heading font-extrabold text-slate-900 sm:leading-[1.05] mb-4 sm:mb-8 max-w-3xl" data-id="element-40" data-mp="2p63ka8r4jqm5">
              Todo tu año de pádel{' '}
              <span className="text-court-deep" data-id="element-41" data-mp="2z26n7gtsvta5">resuelto.</span>
            </h1>

            {/* PRODUCT IMAGE */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.92
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative mb-6 sm:mb-10" data-id="element-42" data-mp="2u452krgq7lwk">
              <img src="https://cdn.magicpatterns.com/uploads/idQcamCpECnLCfajXPgUnv/348.png" alt="PADEL 360 con los 12 Tomos y los 6 Bonus incluidos" width="576" height="576" fetchPriority="high" decoding="async" className="relative w-auto max-h-[34vh] sm:max-h-none sm:w-full sm:max-w-lg mx-auto h-auto drop-shadow-2xl" data-id="element-43" data-mp="18sms5lo7t8z7" />
            </motion.div>

            <p className="text-lg sm:text-2xl text-court-deep font-heading font-bold mb-4 max-w-2xl leading-snug" data-id="element-44" data-mp="3rsyv1z6tjsl8">
              "Listo para usar. Sin improvisar. Sin perder domingos."
            </p>

            <p className="text-sm sm:text-lg text-slate-600 mb-7 max-w-xl leading-relaxed" data-id="element-45" data-mp="5dnn0x7t4pr4">
              El sistema completo de planificación, drills y secuencias para el
              profesor de pádel: los 12 Tomos y los 6 Bonus, sin armar nada
              desde cero.
            </p>

            {/* Pills */}
            <div className="flex flex-wrap gap-2 sm:gap-3 mb-8 justify-center" data-id="element-46" data-mp="jcx3zz3u7nw5">
              <Pill icon="📄" text="PDF" data-id="element-47" data-mp="23vhd5fadnl3j" />
              <Pill icon="⚡" text="Acceso inmediato" data-id="element-48" data-mp="23sbou29kon8v" />
              <Pill icon="🌎" text="Español neutro" data-id="element-49" data-mp="1yua4zf4bojwc" />
              <Pill icon="🎾" text="Todos los niveles" data-id="element-50" data-mp="1yxo84pkt8x4u" />
              <Pill icon="📚" text="12 Tomos + 6 Bonus" data-id="element-51" data-mp="1uuj9iy3upflh" />
            </div>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-base sm:text-xl font-heading font-extrabold py-4 sm:py-5 px-8 sm:px-12 rounded-xl shadow-xl shadow-orange-500/30 transition-all hover:scale-[1.03] flex items-center justify-center gap-3 uppercase tracking-wide" data-id="element-52" data-mp="1pvf0c7gxfhv5">
              💪 → QUIERO MI PADEL 360 AHORA
            </button>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-slate-500 font-medium" data-id="element-53" data-mp="28t96mdqo7f9u">
              <span className="flex items-center gap-1.5" data-id="element-54" data-mp="31igaztct2z30">
                <ShieldCheck className="w-4 h-4 text-court-deep" data-id="element-55" data-mp="31g3msyggfshi" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-56" data-mp="2q1qvgkcaqgmp">
                <Lock className="w-4 h-4 text-court-deep" data-id="element-57" data-mp="2q3bq09ym1zkk" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-58" data-mp="2c3aocsaiuo41">
                <CreditCard className="w-4 h-4 text-court-deep" data-id="element-59" data-mp="2h0snxs2nfqzd" /> Tarjetas y
                transferencia
              </span>
            </div>
          </motion.div>
        </div>

        {/* Trust Badges */}
        <div className="max-w-4xl mx-auto mt-16 sm:mt-20 pt-10 border-t border-slate-200" data-id="element-60" data-mp="38srq4w6dvq0g">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-61" data-mp="2v13k9amq9xrx">
            <div data-id="element-62" data-mp="2uz0qcfigfkhx">
              <p className="text-3xl font-heading font-extrabold text-slate-900" data-id="element-63" data-mp="2zzofevn4hr9i">
                +300
              </p>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider mt-1" data-id="element-64" data-mp="3nohidc25wzdm">
                profes en Latinoamérica
              </p>
            </div>
            <div data-id="element-65" data-mp="5p53g5rjffq7">
              <p className="text-3xl font-heading font-extrabold text-slate-900" data-id="element-66" data-mp="5ollwq5sutcp">
                12+6
              </p>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider mt-1" data-id="element-67" data-mp="1njugvi4jlla">
                Tomos + Bonus
              </p>
            </div>
            <div data-id="element-68" data-mp="ag3n9fbqivy7">
              <p className="text-3xl font-heading font-extrabold text-slate-900" data-id="element-69" data-mp="ahogn1mbc8uh">
                4.9/5
              </p>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider mt-1" data-id="element-70" data-mp="3iwgjr5c5olqn">
                calificación
              </p>
            </div>
            <div className="flex flex-col items-center justify-center" data-id="element-71" data-mp="3sv5tubxt91wc">
              <div className="flex text-amber-400 mb-1" data-id="element-72" data-mp="3nuqgvlhfxwew">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-73" data-mp="183cfdt68r396" data-mpi={i} />)}
              </div>
              <p className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-74" data-mp="135u1rpha3zuu">
                profes satisfechos
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 - INITIAL TESTIMONIALS */}
      <section className="py-16 sm:py-20 bg-white px-4 sm:px-6 lg:px-8" data-id="element-75" data-mp="1k6f26ia0fcxm">
        <div className="max-w-7xl mx-auto" data-id="element-76" data-mp="1k77yepbcek1i">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-77" data-mp="1p61f0qlxer5w">
            <TestimonialCard initials="MP" quote="Organicé todo el mes de clases en una tarde. Nunca más llego a la cancha sin saber qué drill voy a dar." name="Martín P., Buenos Aires" role="Profesor de Pádel en Club Privado" data-id="element-78" data-mp="1p3f54kbkbzki" />
            <TestimonialCard initials="CG" quote="Mis alumnos de nivel inicial mejoraron su posición en cancha desde la primera semana con el Tomo 2. Nunca había visto eso tan rápido." name="Carolina G., Bogotá" role="Profesora de Pádel Independiente" data-id="element-79" data-mp="11dud7bxflrz3" />
            <TestimonialCard initials="FR" quote="Antes tardaba 1 hora armando la clase. Ahora abro el tomo que corresponde y en 5 minutos estoy listo." name="Federico R., Santiago" role="Profesor de Pádel en Academia" data-id="element-80" data-mp="66jz6kuvawzw" />
          </div>
        </div>
      </section>

      {/* SECTION 3 - PAIN SECTION */}
      <section className="py-20 bg-court-deep px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-81" data-mp="3nh1lqs2llu6t">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-82" data-mp="3jeoj4cj5ece9">
          <h2 className="text-2xl sm:text-4xl font-heading font-extrabold mb-12 text-center text-white leading-tight" data-id="element-83" data-mp="3emdit8khwol6">
            Si eres profe de pádel, esto te va a{' '}
            <span className="text-amber-300" data-id="element-84" data-mp="34opm4d3bx70d">sonar conocido:</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-14" data-id="element-85" data-mp="34mmkswwq7rgc">
            <PainPoint text="Llegas a la cancha sin saber exactamente qué drill vas a dar hoy" data-id="element-86" data-mp="2zol2ie74jw5x" />
            <PainPoint text="Tus alumnos no progresan porque no hay un orden claro de contenidos" data-id="element-87" data-mp="2voaukvzruvof" />
            <PainPoint text="Tienes grupos con niveles mezclados y no sabes cómo manejarlos" data-id="element-88" data-mp="nfuo59ky5plx" />
            <PainPoint text="Un alumno falta 2 semanas y pierdes la continuidad de todo el grupo" data-id="element-89" data-mp="sdnv44u2qnn9" />
            <PainPoint text="No puedes justificar un aumento de precio porque no tienes nada sistematizado" data-id="element-90" data-mp="dgdi2r1s99pf" />
            <PainPoint text="El domingo por la noche te llega la ansiedad sin saber qué dar el lunes" data-id="element-91" data-mp="ie5dvw5jtfyw" />
            <PainPoint text="Repites los mismos drills una y otra vez porque no tienes más variantes y los alumnos se aburren" data-id="element-92" data-mp="4midbk4kplab" />
            <PainPoint text="Nadie valora tu trabajo porque no se refleja en un progreso concreto y visible" data-id="element-93" data-mp="3qw1qncrmlgt4" />
          </div>

          <div className="text-center bg-white/10 p-8 sm:p-10 rounded-2xl border border-white/15" data-id="element-94" data-mp="3vvxw7gfz1gas">
            <h3 className="text-2xl sm:text-4xl font-heading font-extrabold text-amber-300 mb-8" data-id="element-95" data-mp="3hw6aetj7qvm8">
              "¿Cuántas clases más vas a improvisar?"
            </h3>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-base sm:text-xl font-heading font-extrabold py-4 sm:py-5 px-8 rounded-xl shadow-xl shadow-orange-900/30 transition-all hover:scale-[1.03] flex items-center justify-center gap-3 uppercase mx-auto" data-id="element-96" data-mp="3384vz1q5miwv">
              👉 BASTA DE IMPROVISAR
            </button>
          </div>
        </div>
      </section>
    </div>;
}
function Pill({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 text-slate-700 rounded-full text-xs sm:text-sm font-medium shadow-sm" data-id="element-97" data-mp="3h7o0zlno5e4y">
      <span data-id="element-98" data-mp="3qz1xrlo8jzue">{icon}</span>
      {text}
    </span>;
}
function TestimonialCard({
  initials,
  quote,
  name,
  role
}: {
  initials: string;
  quote: string;
  name: string;
  role: string;
}) {
  return <div className="bg-slate-50 rounded-2xl p-7 border border-slate-200" data-id="element-99" data-mp="3ucare7hxjeu">
      <div className="flex items-center gap-4 mb-5" data-id="element-100" data-mp="2qt4xvh1dj781">
        <div className="w-11 h-11 rounded-full bg-court-deep text-white flex items-center justify-center font-bold" data-id="element-101" data-mp="2qtwijwtfnkjj">
          {initials}
        </div>
        <div className="flex text-amber-400" data-id="element-102" data-mp="2hzi4fxkn2g20">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-103" data-mp="2d1qe37zn71zx" data-mpi={i} />)}
        </div>
      </div>
      <p className="text-slate-700 mb-5 leading-relaxed" data-id="element-104" data-mp="39r7jdlupqm13">"{quote}"</p>
      <div data-id="element-105" data-mp="39p4s6yhtqmus">
        <p className="font-bold text-slate-900 text-sm" data-id="element-106" data-mp="35pvxnreymky6">{name}</p>
        <p className="text-xs text-slate-500 mt-0.5" data-id="element-107" data-mp="35qnj49euf2aq">{role}</p>
      </div>
    </div>;
}
function PainPoint({
  text
}: {
  text: string;
}) {
  return <div className="flex items-start gap-3 bg-white/[0.07] p-5 rounded-xl border border-white/10" data-id="element-108" data-mp="2vs7qg2063kz4">
      <XCircle className="w-5 h-5 text-red-300 flex-shrink-0 mt-0.5" data-id="element-109" data-mp="1pc5hhmakg686" />
      <p className="text-blue-50 leading-snug" data-id="element-110" data-mp="1p99kq1agfnlb">{text}</p>
    </div>;
}